module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Refresh_16"],"path":[{"$":{"d":"M15,7V1L12.94,3.06a7,7,0,1,0,1.35,8l-2-1a4.76,4.76,0,1,1-.92-5.43L9,7Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Refresh_16.svg
// module id = rcHo
// module chunks = 1